"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _passengerRoomSelection = _interopRequireDefault(require("@airasia/phoenix-components/components/PassengerRoomSelection/passengerRoomSelection.util"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var MultiRoomSelectUtils = {
  updateRoomOccupancy: function updateRoomOccupancy(roomOccupancy, min, defaultRoomOccupancy) {
    return _passengerRoomSelection.default.updateRoomOccupancy(roomOccupancy, +min, defaultRoomOccupancy);
  },
  getTotalGuests: function getTotalGuests(paxCount) {
    return _passengerRoomSelection.default.getTotalGuests(paxCount);
  },
  generatePassengerRoomSelectionData: function generatePassengerRoomSelectionData(data, updatedRoomOccupancy, defaultRoomOccupancy, childAge) {
    var adult = data.adult,
        child = data.child,
        infant = data.infant,
        labels = data.labels,
        ageList = data.ageList;

    var constructedData = _objectSpread(_objectSpread({}, data), {}, {
      minRooms: +(data === null || data === void 0 ? void 0 : data.minRooms),
      maxRooms: +(data === null || data === void 0 ? void 0 : data.maxRooms),
      minPassengers: +(data === null || data === void 0 ? void 0 : data.minPassengers),
      maxPassengers: +(data === null || data === void 0 ? void 0 : data.maxPassengers),
      maxPassengersPerRoom: +(data === null || data === void 0 ? void 0 : data.maxPassengersPerRoom),
      adult: _objectSpread(_objectSpread({}, adult), {}, {
        type: 'adult',
        label: labels.adultSingle,
        subLabel: labels.adultAgeLimit ? labels.adultAgeLimit : labels.childAgeLimit
      }),
      child: _objectSpread(_objectSpread({}, child), {}, {
        type: 'child',
        label: labels.childSingle,
        subLabel: labels.childAgeLimit
      }),
      infant: _objectSpread(_objectSpread({}, infant), {}, {
        type: 'infant',
        label: labels.infantSingle,
        subLabel: labels.infantAgeLimit
      }),
      defaultRoomOccupancy: defaultRoomOccupancy,
      roomOccupancy: updatedRoomOccupancy,
      roomChildAge: childAge,
      ageList: ageList
    });

    return constructedData;
  }
};
var _default = MultiRoomSelectUtils;
exports.default = _default;